import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, useForm } from "react-hook-form";
import { Col, Container, Row, Button, Form } from "react-bootstrap";
import IMG_Info from "../../../../assets/images/icon/info.png";
import PricingModal from "../../../../shared/components/Modals/PricingModal";
import AddLocationModal from "../Modals/AddLocation";
import { centerActions } from "../../../../redux/actions";
import { getSportObjByName, replaceSportsIdWithName } from "../../../../system";
import {
  roles,
  Directions,
  spotConstants,
  globalGridActions,
  translationConstants,
} from "../../../../constants";
import DataTableWithoutPagination from "../../../../shared/components/Table/DataTableWithoutPagination";
import CustomModal from "../../../../shared/components/CustomModal/CustomModal";
import { ToastifyService } from "../../../../services";

let updatedSpots = [];

const LocationsTab = ({ goBack, onNext }) => {
  const methods = useForm();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const formState = useSelector((state) => state.centerReducer.formState);
  const spots =
    useSelector((state) => state.centerReducer.formState?.spots) || [];
  const subscriptionPrices =
    useSelector((state) => state.SubscriptionReducer.subscriptionPrices) || [];
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  const [modalData, setModalData] = useState(null);
  const [pricingData, setPricingData] = useState({ totalFees: 0 });
  const [pricingModal, setPricingModal] = useState(false);
  const [addLocationModal, setAddLocationModal] = useState(false);
  const [existingSpotCoordinates, setExistingSpotCoordinates] = useState(null);

  const getFilteredLatLongList = () => {
    return updatedSpots
      ?.map((obj, index) => ({ ...obj, rowIndex: index }))
      .map((obj) => ({
        lat: obj?.spotInfo?.spotInfo?.lat || obj?.publicSpotLat,
        long: obj?.spotInfo?.spotInfo?.long || obj?.publicSpotLng,
        rowIndex: obj.rowIndex,
      }));
  };

  const getRowData = (row, action, spots) => {
    switch (action) {
      case globalGridActions.EDIT:
        toggleAddLocationModal();
        setModalData({ ...row, disabled: false });
        break;

      case globalGridActions.VIEW:
        toggleAddLocationModal();
        setModalData({ ...row, disabled: true });
        break;

      case globalGridActions.DELETE:
        let updatedData = {
          ...formState,
          spots: [...spots.slice(0, row), ...spots.slice(row + 1)],
        };
        dispatch(centerActions.setFormState(updatedData));
        break;

      default:
        break;
    }
  };

  const [columns] = useState([
    {
      id: "spotInfo.spotInfo.name",
      name: t(translationConstants.SPOT_NAME),
      selector: (row) => row.spotName || row.spotInfo.spotInfo.name,
    },
    {
      id: "spotTypeId",
      name: t(translationConstants.LOCATION_TYPE),
      selector: (row) =>
        `${
          row.spotTypeId === spotConstants.spotType.PUBLIC
            ? t(translationConstants.PUBLIC_SPOT)
            : t(translationConstants.PRIVATE_SPOT)
        }`,
    },
    {
      id: "sports",
      name: t(translationConstants.SPORTS),
      selector: (row) => replaceSportsIdWithName(row.centerSpotSports, t),
    },
    {
      id: "actions",
      name: t(translationConstants.Actions),
      selector: (row, rowIndex) => (
        <div className="d-flex justify-content-center">
          <svg
            onClick={() =>
              getRowData({ ...row, rowIndex: rowIndex }, globalGridActions.VIEW)
            }
            width="20"
            height="20"
            // viewBox="0 0 50 16"
            viewBox={direction === Directions.rtl ? "0 0 20 16" : "0 0 20 16"}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.1685 8.99922C16.1685 8.99922 14.0341 13.268 9.05391 13.268C4.07371 13.268 1.93933 8.99922 1.93933 8.99922C1.93933 8.99922 4.07371 4.73047 9.05391 4.73047C14.0341 4.73047 16.1685 8.99922 16.1685 8.99922Z"
              stroke="#588930"
              strokeWidth="1.42292"
              strokeLinecap="round"
            />
            <circle
              cx="9.05381"
              cy="8.99766"
              r="2.13438"
              stroke="#588930"
              strokeWidth="1.42292"
              strokeLinecap="round"
            />
          </svg>
          <svg
            onClick={() =>
              getRowData({ ...row, rowIndex: rowIndex }, globalGridActions.EDIT)
            }
            width="20"
            height="20"
            viewBox={direction === Directions.rtl ? "22 2 20 11" : "20 0 20 16"}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.4449 13.2687V9.53359H35.3778V13.2687H26.8403V4.73125H30.5754V3.66406H26.8403C26.2509 3.66406 25.7731 4.14186 25.7731 4.73125V13.2687C25.7731 13.8581 26.2509 14.3359 26.8403 14.3359H35.3778C35.9671 14.3359 36.4449 13.8581 36.4449 13.2687ZM34.9392 4.05008C34.6946 3.80355 34.3597 3.66406 34.0103 3.66406C33.6614 3.66406 33.3268 3.80324 33.0808 4.05072L28.6153 8.51625C28.2162 8.86785 27.9546 9.39104 27.9092 9.95369L27.9074 11.6692V12.2028H30.1136C30.7189 12.1613 31.2472 11.8971 31.6199 11.4672L36.0602 7.02882C36.3066 6.78247 36.445 6.44835 36.445 6.09996C36.445 5.75157 36.3066 5.41745 36.0602 5.1711L34.9392 4.05008ZM30.076 11.1359C30.3611 11.1157 30.6264 10.9831 30.8395 10.7393L34.075 7.50381L32.6054 6.03405L29.3461 9.29222C29.1299 9.48342 28.9962 9.75092 28.9747 9.99562V11.1349L30.076 11.1359ZM33.3601 5.27956L34.8296 6.7492L35.3057 6.27316C35.3519 6.22695 35.3778 6.16427 35.3778 6.09892C35.3778 6.03357 35.3519 5.97089 35.3057 5.92468L34.1832 4.80217C34.1375 4.75611 34.0753 4.73021 34.0104 4.73021C33.9455 4.73021 33.8833 4.75611 33.8376 4.80217L33.3601 5.27956Z"
              fill="#2C7465"
            />
          </svg>
          <svg
            onClick={() =>
              getRowData(rowIndex, globalGridActions.DELETE, updatedSpots)
            }
            width="20"
            height="20"
            viewBox={direction === Directions.rtl ? "40 0 20 16" : "40 0 20 16"}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ overflow: "hidden" }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M48.7769 2.47656H52.3342C52.9891 2.47656 53.5199 3.00745 53.5199 3.66233V4.25521H55.2987C55.9536 4.25521 56.4845 4.78609 56.4845 5.44097V6.62674C56.4845 7.28162 55.9536 7.8125 55.2987 7.8125H55.2512L54.7059 14.3344C54.7059 14.9893 54.175 15.5201 53.5201 15.5201H47.5913C46.9364 15.5201 46.4055 14.9893 46.4076 14.3836L45.86 7.8125H45.8126C45.1577 7.8125 44.6268 7.28162 44.6268 6.62674V5.44097C44.6268 4.78609 45.1577 4.25521 45.8126 4.25521H47.5911V3.66233C47.5911 3.00745 48.122 2.47656 48.7769 2.47656ZM47.5911 5.44097V5.44092H45.8126V6.62668H55.2987V5.44092H53.5199V5.44097H47.5911ZM47.5913 14.3344L47.0497 7.81268H54.0615L53.5222 14.2851L53.5201 14.3344H47.5913ZM52.3345 3.66243V4.25532H48.7772V3.66243H52.3345Z"
              fill="#FF0000"
            />
          </svg>
        </div>
      ),
    },
  ]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const toggleAddLocationModal = () => {
    if (addLocationModal) {
      setModalData(null);
    }
    const filteredLatLongList = getFilteredLatLongList();
    setExistingSpotCoordinates(filteredLatLongList);
    setAddLocationModal((prev) => !prev);
  };

  const onLocationSubmit = (dataToSend) => {
    let updatedSpots = [...spots];
    const { rowIndex, ...data } = dataToSend;

    if (typeof rowIndex === "number") updatedSpots[rowIndex] = data;
    else updatedSpots = [...updatedSpots, dataToSend];
    dataToSend = { ...formState, spots: updatedSpots };
    dispatch(centerActions.setFormState(dataToSend));
    calculateLocationsPricing(updatedSpots);
    toggleAddLocationModal();
  };

  const onSubmit = (dataToSend) => {
    if (!formState?.spots?.length > 0) {
      ToastifyService.showError(translationConstants.ATLEAST_ONE_LOCATION);
      return;
    }
    onNext();
  };

  const getPriceBySportId = (id, centerPricing) =>
    centerPricing.find((x) => x.subcriptionType === id)?.price;

  const calculateLocationsPricing = (spots) => {
    // Initialize variables
    let pricing = [];
    let subTotal = 0;
    let centerPricing = subscriptionPrices.filter(
      (subs) => subs.userType === roles.Center
    );
    // Iterate through each spot
    spots.forEach((spot) => {
      let sports = [];
      // Calculate pricing for public spots
      if (`${spot.spotTypeId}` === `${spotConstants.spotType.PUBLIC}`) {
        sports = Array.isArray(spot.centerSpotSports)
          ? spot.centerSpotSports
          : [spot.centerSpotSports];

        pricing.push({
          name: spot.spotName,
          sports: sports?.map((sport) => {
            // Assuming price calculation logic here
            let price = getPriceBySportId(+sport, centerPricing); // Placeholder for actual price calculation
            subTotal += price;
            return {
              name: getSportObjByName(sport)?.label,
              price: price,
            };
          }),
        });
      }
      // Calculate pricing for private spots
      else if (`${spot.spotTypeId}` === `${spotConstants.spotType.PRIVATE}`) {
        sports = Array.isArray(spot.centerSpotSports)
          ? spot.centerSpotSports
          : [spot.centerSpotSports];

        pricing.push({
          name: spot?.spotName, // Access spotInfo safely
          sports:
            sports.map((sport) => {
              // Assuming price calculation logic here
              let price = getPriceBySportId(+sport, centerPricing); // Placeholder for actual price calculation
              subTotal += price;
              return {
                name: getSportObjByName(sport)?.label,
                price: price,
              };
            }) || [],
        });
      }
    });

    // Calculate VAT and total fees
    const VAT = subscriptionPrices.filter((subs) => subs.userType === null);
    const vatValue = (VAT[0].price / 100) * subTotal;

    // Set pricing data state
    setPricingData({
      vat: VAT[0].price,
      vatValue: vatValue,
      subTotal: subTotal || 0,
      locations: pricing || [],
      totalFees: subTotal + vatValue || 0,
    });
  };

  useEffect(() => {
    updatedSpots = spots;
    calculateLocationsPricing(spots);
  }, [spots]);

  return (
    <>
      <FormProvider {...methods}>
        <Form noValidate onSubmit={handleSubmit(onSubmit)}>
          <Container>
            <Row>
              <Col
                md={12}
                className="d-flex justify-content-center justify-content-md-end p-0 mb-2"
              >
                <Button
                  className="Registeration-button m-0"
                  type="button"
                  onClick={toggleAddLocationModal}
                >
                  <svg
                    width="13"
                    height="14"
                    viewBox="0 0 13 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.6239 7.87686L0.305033 7.87686L0.305033 6.12465L5.6239 6.12465L5.6239 0.805788H7.3761L7.3761 6.12465L12.695 6.12465L12.695 7.87686L7.3761 7.87686L7.3761 13.1957H5.6239L5.6239 7.87686Z"
                      fill="white"
                    />
                  </svg>
                  &nbsp;
                  {t(translationConstants.ADD_LOCATION)}
                </Button>
              </Col>

              <Col md={12} className="p-0">
                <DataTableWithoutPagination columns={columns} data={spots} />
              </Col>

              <Col md={6} className="p-0">
                <p className="text-dark">
                  <span className="font-weight-700">
                    {t(translationConstants.TOTAL_FEE)}:
                  </span>{" "}
                  ({t(translationConstants.SPORT_LOCATION)})
                </p>
                <span className="text-dark font-weight-400">
                  {t(translationConstants.TO_BE_PAID_AFTER_APPROVAL)}
                </span>
              </Col>
              <Col
                md={6}
                className={`p-0 
                  ${
                    direction === Directions.ltr
                      ? "text-start text-md-end"
                      : "text-end text-md-start"
                  }
                  `}
                dir={direction}
              >
                <p
                  className="text-dark font-10 font-weight-400"
                  dir={direction}
                >
                  {translationConstants.SAR} {pricingData.totalFees.toFixed(2)}{" "}
                  <img
                    alt="info-icon"
                    src={IMG_Info}
                    className="info-icon"
                    onClick={() => setPricingModal((prev) => !prev)}
                  />
                </p>
                <p
                  className="text-dark font-10 font-weight-400"
                  dir={direction}
                >
                  {t(translationConstants.BILLED_ANNUALLY)}
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12} className="d-flex justify-content-center mt-4">
                <div className="d-flex">
                  <Button
                    type="button"
                    variant="outline-primary"
                    onClick={goBack}
                    className="btn-submit-outline mx-2"
                  >
                    {t(translationConstants.GO_BACK)}
                  </Button>
                  <Button type="submit" className="btn-submit mx-2">
                    {t(translationConstants.NEXT)}
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </Form>
      </FormProvider>

      <CustomModal
        size="lg"
        scrollable
        show={addLocationModal}
        customClass="custom-modal"
        setShow={toggleAddLocationModal}
      >
        <AddLocationModal
          onSubmit={onLocationSubmit}
          modalData={modalData}
          existingSpotCoordinates={existingSpotCoordinates}
        />
      </CustomModal>

      <CustomModal
        size={"sm"}
        scrollable
        show={pricingModal}
        setShow={setPricingModal}
        closeBtnClasses={"login-modal-close-btn"}
        customClass={"freelance-instructor-model-sm"}
        closeOnOutsideClick={true}
      >
        <PricingModal data={pricingData} isCenterSubscription={true} />
      </CustomModal>
    </>
  );
};

export default LocationsTab;
